import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import Vue from 'vue';
import Vuex from 'vuex';
import base from "./base"; // import createLogger from 'vuex/dist/logger'
// import { devSetting } from '../setting';

Vue.use(Vuex); // if (devSetting.调试模式) {
//    base.plugins = [createLogger()]
// }

export var store = new Vuex.Store(base);
export function setup() {
  return _setup.apply(this, arguments);
}

function _setup() {
  _setup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref,
        _ref$use,
        use,
        _ref$modules,
        modules,
        _ref$moduleOptions,
        moduleOptions,
        key,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$use = _ref.use, use = _ref$use === void 0 ? true : _ref$use, _ref$modules = _ref.modules, modules = _ref$modules === void 0 ? {} : _ref$modules, _ref$moduleOptions = _ref.moduleOptions, moduleOptions = _ref$moduleOptions === void 0 ? {
              preserveState: false
            } : _ref$moduleOptions;

            for (key in modules) {
              store.registerModule(key, modules[key], moduleOptions);
            }

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setup.apply(this, arguments);
}